module.exports = __webpack_public_path__ + "static/illustration-3-e960733124c50746036d838ce5042ae3.jpg";